export const CBOCODE = {
  CAREGIVER: '516210',
  DENTIST: '223208',
  DOCTOR: '225125',
  NURSE: '223505',
  NURSING_ASSISTANT: '322230',
  NURSING_TECHNICIAN: '322205',
  OCCUPATIONAL_THERAPIST: '223905',
  PHYSIOTHERAPIST: '223605',
  PSYCHOLOGIST: '251510',
  NUTRITIONIST: '223710',
  SOCIAL_WORKER: '251605',
  SPEECH_THERAPIST: '223810',
  ATTENDANT: 'atendente'
};
